// frontend/src/App.js — routing only
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Layout       from './components/layout/Layout';
import HomePage     from './pages/HomePage';
import SearchPage   from './pages/SearchPage';
import VersePage    from './pages/VersePage';
import BrowsePage   from './pages/BrowsePage';
import CategoryPage from './pages/CategoryPage';
import DebugPage from './pages/DebugPage';
import CorpusPage   from './pages/CorpusPage';
import AdminPage    from './pages/AdminPage';
import PrivacyPage  from './pages/PrivacyPage';
import CorpusStatsPage from './pages/CorpusStatsPage';
import SettingsPage from './pages/SettingsPage';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index                        element={<HomePage />}     />
          <Route path="search"               element={<SearchPage />}   />
          <Route path="verse/:verseId"       element={<VersePage />}    />
          <Route path="browse"               element={<BrowsePage />}   />
          <Route path="browse/:catId"        element={<CategoryPage />} />
          <Route path="browse/:catId/:subId" element={<CorpusPage />}   />
          <Route path="debug" element={<DebugPage />} />
          <Route path="settings"             element={<SettingsPage />} />
          <Route path="privacy"              element={<PrivacyPage />}  />
          <Route path="admin"               element={<AdminPage />}   />
          <Route path="corpus"              element={<CorpusStatsPage />} />
          <Route path="*"                    element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}


